import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
import { Brain, MessageCircle, Heart, RefreshCw, Wind, Rocket, Lock } from 'lucide-react';
const tomos = [{
  icon: Brain,
  title: 'Entendé tu mente',
  desc: 'Por qué sobrepensás y cómo funciona tu cabeza',
  tag: 'FUNDAMENTAL'
}, {
  icon: MessageCircle,
  title: 'Control del sobrepensamiento',
  desc: 'Técnicas para frenar pensamientos en el momento',
  tag: 'MÁS PEDIDO'
}, {
  icon: Heart,
  title: 'Regulación emocional',
  desc: 'Manejá lo que sentís sin bloquearte',
  tag: 'CLAVE'
}, {
  icon: RefreshCw,
  title: 'Reprogramación mental',
  desc: 'Cambiá patrones que te frenan',
  tag: 'AVANZADO'
}, {
  icon: Wind,
  title: 'Calma mental práctica',
  desc: 'Ejercicios para bajar ansiedad rápido',
  tag: 'FAVORITO'
}, {
  icon: Rocket,
  title: 'Acción y cambio real',
  desc: 'Llevá todo a tu vida diaria',
  tag: 'TRANSFORMADOR'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function Tomos() {
  return <AnimatedSection className="bg-cream text-navy py-12 md:py-16" data-id="element-137">
      <div className="text-center mb-10" data-id="element-138">
        <span className="inline-block bg-orange text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-139">
          Acceso inmediato
        </span>
        <h2 className="text-2xl md:text-4xl font-heading font-bold mb-3" data-id="element-140">
          📚 6 Tomos Completos
        </h2>
        <p className="text-navy-light text-base md:text-lg max-w-xl mx-auto" data-id="element-141">
          Sistema paso a paso para recuperar tu claridad mental.{' '}
          <span className="text-orange font-bold" data-id="element-142">Valor total: $49.990</span> —
          hoy incluido en tu kit.
        </p>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-143">
        {tomos.map((tomo, idx) => {
        const Icon = tomo.icon;
        return <motion.div key={idx} variants={cardVariants} whileHover={{
          y: -4,
          boxShadow: '0 8px 30px rgba(232,131,58,0.15)'
        }} className="bg-white rounded-xl p-5 border border-orange/10 relative overflow-hidden group cursor-default transition-colors hover:border-orange/40" data-id="element-144">
              {/* Tag */}
              <span className="absolute top-3 right-3 bg-navy text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-md" data-id="element-145">
                {tomo.tag}
              </span>

              {/* Number */}
              <span className="absolute -bottom-3 -right-1 text-7xl font-heading font-bold text-orange/5 select-none pointer-events-none" data-id="element-146">
                {idx + 1}
              </span>

              <div className="bg-orange/10 p-2.5 rounded-lg shrink-0 w-fit mb-3 group-hover:bg-orange/20 transition-colors" data-id="element-147">
                <Icon size={24} className="text-orange" data-id="element-148" />
              </div>
              <h3 className="font-heading font-bold text-base text-navy mb-1" data-id="element-149">
                Tomo {idx + 1}: {tomo.title}
              </h3>
              <p className="text-navy-light text-sm" data-id="element-150">{tomo.desc}</p>

              {/* Unlock indicator */}
              <div className="flex items-center gap-1.5 mt-3 text-xs text-orange font-medium" data-id="element-151">
                <Lock size={12} data-id="element-152" />
                <span data-id="element-153">Incluido en el kit</span>
              </div>
            </motion.div>;
      })}
      </motion.div>
    </AnimatedSection>;
}